import styled, { css } from "styled-components";

interface SwitchProps {
  isSelected: boolean;
}

export const Container = styled.div`
  display: flex;
  margin: 2rem 0;
  justify-content: center;

  button:nth-child(1) {
    margin-right: -10px;
  }

  button:nth-child(2) {
    margin-left: -10px;
  }
`;

export const OptionSwitch = styled.button<SwitchProps>`
  display: flex;
  justify-content: center;
  width: 50%;
  border-radius: 40px;
  border: 0;
  box-shadow: 0px 1px 2px 2px rgba(0, 0, 0, 0.1);
  padding: 0.25rem 0;

  ${({ isSelected, theme }) =>
    isSelected &&
    css`
      color: ${theme.colors.white};
      background-color: ${theme.colors.primary};
      z-index: 2;
    `}

  ${({ isSelected, theme }) =>
    !isSelected &&
    css`
      color: ${theme.colors.primary};
      background-color: ${theme.colors.white};
      z-index: 1;
    `}

  p {
    margin: 0;
    padding: 0.25rem 0;
    font-weight: bold;
    font-size: 0.875rem;

    @media (min-width: 768px) {
      font-size: 1rem;
    }
  }
`;
